import { Exclude, Type } from "class-transformer";

export class PostcodeArea {
    _id?: string;

    postcodeStart: string;
    postcodeEnd: string;

    version?: number;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created?: Date;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    updated?: Date;
}
